import React, {useEffect, useState} from 'react';
import analytics from '@react-native-firebase/analytics';
import {CustomPanel, PanelImage, Container, Content, Footer, Form, InputGroup, ButtonWrapper, FinesCardWrapper} from './styles';
import {Header} from '../../components/Interface/Headers/Header';
import {useNavigation} from '@react-navigation/native';
import {Titles} from '../../components/Interface/Typographies/Titles';
import {Input} from '../../components/Interface/Forms/Inputs/Input';
import {Keyboard, Platform, TouchableWithoutFeedback} from 'react-native';
import {Button} from '../../components/Interface/Forms/Buttons/Button';
import { useAuth } from '../../context/auth';
import {addInAppTrigger} from '../../lib/pushMessaging';
import {Ads} from '../../components/shared/Ads';
import {useGlobal} from '../../context/global';
import {Maintenance} from '../../components/Interface/Maintenance';
import {FinesReminderCard} from '../../components/shared/FinesReminderCard';

export function Fipe() {
  const navigation = useNavigation();
  const [placa, setPlaca] = useState('');
  const {isLogged} = useAuth();
  const {fetchBannerFlags, disabledFeatures} = useGlobal();
  const isDisabled = (key: string) => disabledFeatures.includes(key);

  useEffect(() => {
    if(!isLogged){
      navigation.navigate('Home');
    }
  }, [isLogged]);

  useEffect(() => {
    analytics().logEvent('tela_consulta_fipe');
  }, []);

  useEffect(() => {
    fetchBannerFlags();
  }, []);

  function handleChangePlacaText(extracted: any) {
    setPlaca(extracted);
  }

  if (isDisabled('fipe')) {
    return <Maintenance />;
  }

  useEffect(() => {
    if(Platform.OS !== 'web'){
      addInAppTrigger('screen', 'fipe');
    }
  }, []);

  return (
    <TouchableWithoutFeedback onPress={() => Platform.OS !== 'web' && Keyboard.dismiss()}>
      <Container>
        <Header icon="chevron-left" action={() => navigation.canGoBack() ? navigation.goBack() : navigation.navigate('Home')} />
        <Content>
          <Titles
            title="Consultar FIPE"
            subtitle="Consulte a tabela FIPE pela placa do veículo."
          />
          <Form>
            <InputGroup>
              <Input
                labelText="Placa do veículo"
                keyboardType="default"
                placeholder="Digite a placa do veículo"
                mask={'[AAA]-[0-99]'}
                onChangeText={extracted => handleChangePlacaText(extracted)}
                value={placa}
                autoCapitalize="characters"
              />
            </InputGroup>
            <ButtonWrapper>
              <Button
                title="Consultar"
                enabled={placa.length >= 7}
                onPress={() => navigation.navigate('LoadingFipe', {placa})}
              />
            </ButtonWrapper>
            <FinesCardWrapper>
              <FinesReminderCard />
            </FinesCardWrapper>
          </Form>
        </Content>
        <Footer>
          <Ads />
        </Footer>
      </Container>
    </TouchableWithoutFeedback>
  );
}